export default "__VITE_ASSET__B3Q_jRfO__"